import React, { Component } from 'react';
import './AudioPlayer.css'
import remove from '../../src/assets/document/remove.png';
import cross from '../../src/assets/liveclass/remove.png';
// import api from '../../../api/api';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import api from '../api/api'
import URL from "../api/url"
import config from '../config';


class AudioPlayer extends Component {
  myVar3 = "";
  myVar2 = "";
  myVar = "";

  constructor(props) {
    super()

  }

  playVdo = () => {
    let video = new window.VdoPlayer({
      otp: this.props.otp,
      playbackInfo: this.props.playbackInfo,
      theme: "9ae8bbe8dd964ddc9bdb932cca1cb59a",
      container: document.querySelector("#iframeDisplay")
    })
    this.videoObject = video;
  }

  componentDidMount() {
    if (this.props.type && this.props.type == 'vdo') {
      this.playVdo(this.props.data);
    }
    // if (this.props.type && this.props.type == 'file') {
    //   this.myVar3 = setTimeout(() => {
    //     document.getElementById('office').setAttribute('src', 'https://docs.google.com/gview?url=' + this.props.file_name + '&embedded=true');
    //   }, 2000)
    //   this.myVar2 = setTimeout(() => {
    //     document.getElementById('office').setAttribute('src', 'https://docs.google.com/gview?url=' + this.props.file_name + '&embedded=true');
    //   }, 5000)
    //   this.myVar = setTimeout(() => {
    //     document.getElementById('office').setAttribute('src', 'https://docs.google.com/gview?url=' + this.props.file_name + '&embedded=true');
    //   }, 12000)

    // }
  
    document.addEventListener('contextmenu', (event) => event.preventDefault());
  }
  
  
  
  
  componentWillUnmount() {
    clearTimeout(this.myVar);
    clearTimeout(this.myVar2);
    clearTimeout(this.myVar3);
  }

  vdocipherCloseAPI = () => {
    let request = {
      url: "/api/v1/instFileSystem/allocateWatchHistory",
      token: this.props.auth.student_auth,
      data: {
        video_id: this.props.videoID,
        watch_duration: this.videoObject.totalPlayed
      }
    }

    api.postAuth(request).then(data => {
      // console.log(data)

    }).catch((err) => {
      if (err.response && err.response.data) {
        toast.error(err.response.data.message);
      }
    })
  }



  render() {
    const { type, file_name, youtubeVideoID, audiocancle } = this.props;
  const fileExt = file_name?.split(".").pop().toLowerCase();
    return (
      <div className="audioplayer">
        {(this.props.type === "file" || this.props.type === "youtube" || this.props.type === "image") ? (
          <div className="audio" style={{ width: '100%', height: '100vh' }}>
            <button className="audio-button" onClick={() => this.props.audiocancle(false)}>
              <img height="30px" width="30px" src={remove} />
            </button>
            <div className="audio-popup" style={{ width: '100%', height: '100vh' }}>
              
              {/* ✅ Image Preview */}
              {this.props.type === "image" && (
  <div
    style={{
      width: '100%',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'auto' // ⬅️ allows scrolling if image is large
    }}
  >
    <img
      src={this.props.file_name}
      alt="preview"
      style={{
        objectFit: 'contain'
      }}
    />
  </div>
)}

  
              {/* ✅ File (Document) Preview */}
              {type === "file" && (
  <div id="docs" style={{ width: '100%', height: '100vh' }}>
    {fileExt === "pdf" ? (
      // ✅ Render in full-screen iframe instead of window.open
      <iframe
        src={`https://viewpdf.proctur.com/?fileurl=${encodeURIComponent(file_name)}`}
        style={{
          width: '100%',
          height: '100vh',
          border: 'none'
        }}
        sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        allowFullScreen
        title="PDF Viewer"
      />
    ) : (
      <iframe
        id="office"
        src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(file_name)}`}
        style={{ width: '100%', height: '95vh' }}
        frameBorder="0"
        allowFullScreen
        title="Document Viewer"
      />
    )}
  </div>
)}

              {/* ✅ YouTube Video */}
              {this.props.type === "youtube" && (
                <div style={{ width: '100%', height: '100vh' }}>
                  <iframe
                    style={{ height: 'calc(100vh - 40px)', width: '100%', border: 0 }}
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                    title="Video"
                    src={
                      URL[config.env].YOUTUBE_URL +
                      `${this.props.youtubeVideoID}?rel=0&modestbranding=1&controls=1&enablejsapi=1`
                    }
                  ></iframe>
                </div>
              )}
  
            </div>
          </div>
        ) : this.props.type === "unsupported" ? (
          // ✅ Unsupported File Handling (PBIX, ZIP, etc.)
          <div className="audio" style={{ width: '100%', height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <button className="audio-button" onClick={() => this.props.audiocancle(false)}>
              <img height="30px" width="30px" src={remove} />
            </button>
            <p style={{ color: 'gray', fontSize: 18, marginTop: 20 }}>Preview not supported. Please download the file.</p>
          </div>
        ) : (
          <div className="audio">
            <div className="video-overlay">
              <button
                className="audio-button-vim"
                onClick={() => {
                  if (document.fullscreenElement) {
                    document.exitFullscreen();
                  }
  
                  if (this.props.type === 'vdo') {
                    this.vdocipherCloseAPI();
                  }
  
                  this.props.audiocancle(false);
                }}
              >
                <img src={cross} />
              </button>
            </div>
  
            <div className="audio-popup">
  
              {/* ✅ Audio Player */}
              {this.props.type === "audio" && (
  <div className="audio-popup-audio">
    <button className="audio-close-btn" onClick={() => this.props.audiocancle(false)}>
      <img src={remove} alt="close" />
    </button>
    <audio controls autoPlay>
      <source
        src={this.props.audiofileName}
        type={`audio/${(this.props.audiofileName || '').split('.').pop()?.toLowerCase()}`}
      />
      Your browser does not support the audio element.
    </audio>
  </div>
)}


              {/* ✅ VdoCipher */}
              {this.props.type === "vdo" && (
                <div id="iframeDisplay" className='video-player'></div>
              )}
   {
                this.props.type == "vimeo" &&
                <iframe allowFullScreen
                
                  src={`https://player.vimeo.com/video/${this.props.videoID}`}
                />
              }
             
            </div>
          </div>
        )}
      </div>
    );
  }
  
}


const mapStateToProps = state => ({ auth: state.auth })
export default connect(mapStateToProps)(AudioPlayer)